import React from "react";
import { withRouter } from "react-router-dom";
import Auth from "../../services/api/Auth";
import "./style.css";
import { connect } from "react-redux";
import { initRestaurant } from "../../services/store/reducers/restaurant/actions";
import { hasRole, roleInUse, permInUse } from "../../services/Common";

import LoggedAs from "../LoggedAs";

import Restaurant from "../../services/api/Restaurant";
import packageJson from "../../../package.json";

import PopUp from "../PopUp";
import Confirm from "../Confirm";

import { addItem, save } from "../../services/store/reducers/cart/actions";

class Menu extends React.Component {
    constructor(props) {
        super(props);
        let links = [];
        let enableLegacyRoleMenu = false;
        if (
            roleInUse() &&
            (!hasRole("kitchenview_role") ||
                (hasRole("kitchenview_role") &&
                    (hasRole("manager") || hasRole("manager_with_pin"))))
        ) {
            enableLegacyRoleMenu = true;
        }
        if (!roleInUse() && !permInUse()) {
            enableLegacyRoleMenu = true;
        }

        if (!hasRole("courier_role")) {
            if (hasRole("perm_daily_close") || enableLegacyRoleMenu) {
                links.push({
                    path: "daily-close",
                    text: "Napi zárás",
                    enabled: true
                });
            }

            if (hasRole("perm_courier_close") || enableLegacyRoleMenu) {
                links.push({
                    path: "courrier-close",
                    text: "Futár zárás",
                    enabled: true
                });
            }

            if (hasRole("perm_courier_close") || enableLegacyRoleMenu) {
                links.push({
                    path: "detailed-courrier-close",
                    text: "Részletes futár zárás",
                    enabled: true
                });
            }

            if (hasRole("perm_kitcenview") || enableLegacyRoleMenu) {
                links.push({
                    path: "kitchen",
                    text: "Konyha nézet",
                    enabled: true
                });
            }
        }

        if (hasRole("perm_settings") || enableLegacyRoleMenu) {
            links.push({
                path: "settings",
                text: "Beállítás",
                enabled: true
            });
        }

        if (hasRole("admin_menu") || hasRole("perm_admin")) {
            links.push({
                path: "admin",
                text: "Admin",
                enabled: true
            });
        }

        links.push({
            path: "knowledge",
            text: "Segítség",
            enabled: true
        });
        links.push({
            path: "login",
            text: "Kilépés",
            enabled: true
        });

        this.state = {
            active: "",
            links: links,
            popup: false,
            last_target: ""
        };
    }

    logOut = (e) => {
        Auth.logOut();
        // this.props.history.push("/login");
        //window.location.href = '/login'; // we don't want to step back
        window.location.reload();
    };
    toLink = (link) => {
        console.log(this.state.active);
        if (!link.enabled) return;
        return (
            <li
                key={link.path}
                className={this.state.active === link.path ? "active" : ""}
                redirect={link.path}
                action={link.action}
            >
                {link.text}
            </li>
        );
    };

    skipBack = () => {
        let path = window.location.hash;
        let b = path.includes("/table/") || path.includes("/category/") || path.includes("product");
        let table_id = this.props.match.params.table_id;

        return b && this.props.is_saved === false;
    };
    disagreeHandler = (e) => {
        this.setState({ popup: false });
    };
    agreeHandler = () => {
        this.props.addToBasket({ cart_items: [] });
        this.props.save(true);
        this.setState(
            {
                popup: false
            },
            () => {
                let last_target = this.state.last_target;

                if (last_target != "") {
                    this.setState({ active: last_target, popup: false });
                    this.props.close();
                    if (last_target === "login") {
                        this.logOut();
                    } else {
                        this.props.history.push("/" + last_target);
                    }
                }
            }
        );
    };

    redirect = (e) => {
        let last_target = "";
        if (e && e.target.tagName === "LI") {
            last_target = e.target.getAttribute("redirect");
        }

        if (this.skipBack()) {
            this.setState({
                popup: true,
                last_target
            });
            return;
        }

        if (last_target != "") {
            this.setState({ active: last_target });
            this.props.close();
            if (last_target === "login") {
                this.logOut();
            } else {
                this.props.history.push("/" + last_target);
            }
        }
    };
    clickOnFix = (e) => {
        if (e && e.target.tagName === "DIV" && e.target.className === "menu_fix") {
            this.props.close();
        }
    };

    getRestaurant = () => {
        if (typeof this.props.info === "undefined") {
            let partner_id = localStorage.getItem("partner_id");
            Restaurant.getRestaurant(partner_id).then((response) => {
                this.props.initRestaurant(response.data);
                this.enableKitchenMenu();
            });
        }
    };
    componentDidMount = () => {
        this.enableKitchenMenu();
        this.getRestaurant();
    };
    enableKitchenMenu = () => {
        console.log(this.props.info);
        if (
            typeof this.props.info !== "undefined" &&
            typeof this.props.info.enable_kitchen_queue !== "undefined" &&
            this.props.info.enable_kitchen_queue
        ) {
            let links = this.state.links;
            if (typeof links[3] !== "undefined") {
                links[3].enabled = true;
                this.setState({ links });
            }
        }
    };
    render() {
        return (
            <div>
                <div className="menu_fix" onClick={this.clickOnFix}>
                    <div className="menu box_shadow">
                        <p className="logo padding">
                            <img src="images/logo.png" />
                        </p>
                        <LoggedAs />
                        <ul onClick={this.redirect}>{this.state.links.map(this.toLink)}</ul>
                        <div className="version_cont">
                            <small className="version_text">
                                Ver.: {packageJson.version || "n.a"}
                            </small>
                        </div>
                    </div>
                </div>
                {this.state.popup && (
                    <PopUp onClose={this.disagreeHandler} containerClass="popup_small">
                        <Confirm
                            agreeHandler={this.agreeHandler}
                            disagreeHandler={this.disagreeHandler}
                            question={"Biztosan kilépsz mentés nélkül?"}
                        />
                    </PopUp>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        is_saved: state.cart.is_saved,
        info: state.restaurant.data
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addToBasket: (item) => {
            dispatch(addItem(item));
        },
        save: (item) => {
            dispatch(save(item));
        },
        initRestaurant: (data) => {
            dispatch(initRestaurant(data));
        }
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));



// WEBPACK FOOTER //
// ./src/components/Menu/index.js